export default __webpack_public_path__ + "static/media/Group 11815.002ac349.svg";